export class Manufacturer {
  constructor(manufacturer = {}) {
    this.id = manufacturer.id;
    this.type = manufacturer.type;
    this.manufacturer = manufacturer.manufacturer;
    this.imageUrl = manufacturer.image_url;
  }
}
